import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { CardBody } from "../../../_metronic/_partials/controls";
import FiltersCard from "../filters/Filter";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useHistory, useLocation } from "react-router-dom";
import Table, {
  buttonsStyle,
  getCurrentTablePage,
  offerStatusFormatter,
} from "../tables/table";

function getData(offerHeaders, customers, offerStatus) {
  let data = [];
  for (let i = 0; i < offerHeaders.length; ++i) {
    const elem = {};
    const offerHeader = offerHeaders[i];

    elem.estado = offerStatus?.find((x) => x.id === offerHeader?.estado_id);
    elem.numOferta = offerHeader?.num_oferta;
    elem.cliente = customers?.find(
      (x) => x.id === offerHeader?.cliente_id
    )?.nombre;
    elem.localizacion = offerHeader?.localizacion;
    elem.referencia = offerHeader?.referencia;
    elem.revisionNum = offerHeader?.revision_num;
    elem.id = i;

    elem.key = {
      id: offerHeader?.id,
      revisionNum: offerHeader?.revision_num,
    };

    data = data.concat(elem);
  }
  return data;
}

const initialFilters = {};

const OfferRevisionTableDialog = (props) => {
  const { title, open, setOpen, data, customers, offerStatus } = props;

  const [filteredData, setFilteredData] = useState(data);
  const [collapsed, setCollapsed] = useState(true);
  const [filterOptions, setFilterOptions] = useState(initialFilters);

  const [refresh, setRefresh] = useState(false);

  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  useEffect(() => {
    setFilteredData(data);
  }, [open]);

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setFilteredData(data);
  };

  const renderFiltersContent = () => {
    return <></>;
  };

  function buttonFormatter(key) {
    const offerId = key?.id;
    const revisionNum = key?.revisionNum;

    const elem = data.find(
      (item) => item.id === offerId && item.revision_num === revisionNum
    );
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              history.push({
                pathname: `/ofertas/${offerId}/${revisionNum}/edit`,
                state: {
                  page: getCurrentTablePage(location),
                },
              });
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "numOferta", text: "Número de oferta", sort: true },
    {
      dataField: "revisionNum",
      text: "Revisión",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "cliente",
      text: "Cliente",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "localizacion",
      text: "Localización",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "referencia",
      text: "Referencia de obra",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "estado",
      text: "Estado",
      sort: true,
      headerAlign: "center",
      align: "center",
      formatter: offerStatusFormatter,
    },
    { dataField: "key", text: "", formatter: buttonFormatter },
  ];

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
        <DialogTitle id="table-dialog">{title}</DialogTitle>
        <DialogContent>
          <CardBody className="pt-0 px-0">
            <Table
              data={getData(filteredData, customers, offerStatus)}
              columns={columns}
            />
          </CardBody>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
    </>
  );
};
export default OfferRevisionTableDialog;
